// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22Hzp","content":"styles_content__Akq6K","row":"styles_row__20PPu","footer":"styles_footer__263oK","phraseLength":"styles_phraseLength__ntAH_"};